//https://boost.allnetru.dev/api/documentation#/Categories
import { createApi } from '@reduxjs/toolkit/query/react';
import { PostEmailResponse } from 'lib.store/src/main/email/models';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

const email_tag = `email_tag`;

export const email = createApi({
  reducerPath: email_tag,
  baseQuery: baseQueryWithReauth,
  tagTypes: [email_tag],
  endpoints: (build) => ({
    postEmailVerification: build.mutation<PostEmailResponse, void>({
      query: () => ({
        method: 'POST',
        url: `/email/verification-notification`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      invalidatesTags: [email_tag],
    }),
  }),
});

export const { usePostEmailVerificationMutation } = email;
